import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import avatarPath from "../Images/josue.jpg";
import { useLanguage } from "../context/LanguageContext";
import translations from "../i18n/translations";

export default function ChatPopup() {
  const [isOpen, setIsOpen] = useState(false);
  const { language } = useLanguage();
  const t = translations[language];

  const togglePopup = () => setIsOpen(!isOpen);

  const startWhatsAppChat = () => {
    const phoneNumber = "+250798972768";
    const message = t.chat.defaultMessage;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappUrl, "_blank");
    setIsOpen(false);
  };

  return (
    <>
      <button
        onClick={togglePopup}
        className="group fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-300 ease-out hover:scale-110 active:scale-95"
        aria-label="Chat on WhatsApp"
      >
        <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366] opacity-60" />
        <FaWhatsapp className="h-7 w-7 transition-transform duration-300 group-hover:rotate-6" />
      </button>

      {isOpen && (
        <div className="fixed bottom-24 right-6 z-50 w-80 max-w-[calc(100vw-3rem)] origin-bottom-right animate-fade-in-up overflow-hidden rounded-2xl bg-white shadow-2xl ring-1 ring-black/5">
          <div className="flex items-center justify-between bg-[#25D366] px-4 py-3">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-full bg-white ring-2 ring-white/40">
                <img
                  src={avatarPath}
                  alt="Portrait of Josue Rushanika"
                  className="h-full w-full object-cover"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-white">
                  {t.chat.headerTitle}
                </p>
                <p className="flex items-center gap-1 text-xs text-white/90">
                  <span className="h-1.5 w-1.5 rounded-full bg-emerald-200" />
                  {t.chat.headerSubtitle}
                </p>
              </div>
            </div>
            <button
              onClick={togglePopup}
              aria-label="Close chat popup"
              className="text-white/80 transition hover:text-white"
            >
              <IoClose className="h-5 w-5" />
            </button>
          </div>

          <div className="min-h-[180px] bg-[#e5ddd5] p-4">
            <div className="mb-3 max-w-xs rounded-lg rounded-tl-none bg-white p-3 text-sm text-gray-800 shadow-sm">
              <div className="mb-1 text-xs font-medium text-gray-500">
                {t.chat.introName}
              </div>
              <p>
                {t.chat.introMessageLine1}
                <br />
                {t.chat.introMessageLine2}
              </p>
            </div>
          </div>

          <div className="border-t bg-white p-4">
            <button
              onClick={startWhatsAppChat}
              className="flex w-full items-center justify-center gap-2 rounded-full bg-[#25D366] py-2.5 text-sm font-medium text-white shadow-sm transition hover:bg-[#1ebe57] hover:shadow-md"
            >
              <FaWhatsapp className="h-4 w-4" />
              {t.chat.startButton}
            </button>
            <div className="mt-2 text-center text-xs text-gray-400">
              {t.chat.redirectNote}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
